import React, { useContext } from "react";
import { ContentSection } from "sprint-common-web";

import { MuxSpecificationDashboardContext } from "../context/MuxSpecificationDashboardContext";

interface MuxSpecificationTechnicalSectionProps {
    height: number;
    content: React.ReactNode;
}

export const MuxSpecificationTechnicalSection: React.VFC<MuxSpecificationTechnicalSectionProps> = ({
    height,
    content
}: MuxSpecificationTechnicalSectionProps) => {
    const { isLoading } = useContext(MuxSpecificationDashboardContext);

    return (
        <ContentSection header="Parameters" style={{ height }} isLoading={isLoading}>
            {content}
        </ContentSection>
    );
};
